export default {
  id: null,
  codigo: 0,
  funcionarioId: null,
  funcionario: null,
  nome: '',
  obraID: null,
  funcaoObraID: null,
  funcaoObra: null,
  tipoMaoDeObra: null,
  inicioAtividades: null,
  terminoAtividades: null,
  tipoServico: null,
  observacoes: null,
  status: 1
}



// WEBPACK FOOTER //
// ./src/shared/models/pci/constructionmember.js